import { Link as ChakraLink } from '@chakra-ui/react';

import type { JSX } from 'react';

import type { IBaseProps } from './interface';

export function ExternalLink(props: IBaseProps): JSX.Element {
  return <ChakraLink {...props} />;
}
